import { createSlice } from '@reduxjs/toolkit';
import { getSettings } from '../api/settings';

export const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    loading: false,
    error: {},

    settings: {},
  },
  reducers: {
    clearSeetingsError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    [getSettings.pending]: (state) => {
      state.loading = true;
    },
    [getSettings.fulfilled]: (state, action) => {
      state.loading = false;
      state.settings = action.payload;
      state.error = {};
    },
    [getSettings.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearSeetingsError } = settingsSlice.actions;

export default settingsSlice.reducer;
